export const COLORS: string[] = [
  "#EF5350",
  "#EC407A",
  "#BA68C8",
  "#9575CD",
  "#7986CB",
  "#1E88E5",
  "#0288D1",
  "#0097A7",
  "#009688",
  "#43A047",
  "#558B2F",
  "#827717",
  "#E6BF00",
  "#E69100",
  "#F4511E",
  "#A1887F",
  "#78909C",
  "#999999",
  "#757575",
  "#444444",
];
